/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins scroll-smooth;
  display: block;
}

.blog-side-nav {
  @apply sticky top-0 w-full;
}

.related-article-container {
  @apply grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-12px;
}

.related-article-item:hover {
  @apply bg-ui-gray-6;
  transtion: all 0.2s ease-in-out;
}

.card {
  @apply relative ;
}

.card-image-container {
  @apply aspect-video max-w-[125px] rounded-xl overflow-hidden;
}

.card-image {
  @apply aspect-video max-w-[125px] rounded-xl object-cover;
}


.card-text-container {
  @apply md:max-w-[50%] xl:max-w-none;
}

.card-overlay {
  @apply absolute top-0 left-0 w-full h-full  flex items-center justify-center rounded-xl;
}

/* Animate in */@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1 {
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.blog-side-nav.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}